import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '919831072381';  // E.164 without +
const SITE_BASE = typeof window !== 'undefined' && window.location?.origin
  ? window.location.origin
  : 'https://sanatanbhavan.com';

/**
 * One-tap "Order via WhatsApp" button. Opens WhatsApp with a friendly,
 * pre-filled message containing the product name + price + link.
 * - compact=true → icon-only square button (for product card grids)
 * - compact=false → text+icon, full-width primary action
 */
export const WhatsAppOrderButton = ({ product, quantity = 1, compact = false, className = '' }) => {
  if (!product) return null;

  const price = product.sale_price || product.price;
  const productUrl = `${SITE_BASE}/product/${product.id}`;
  const msg =
    `Hi Sanatanbhavan! 🙏\n\n` +
    `I would like to order:\n` +
    `• ${product.name}\n` +
    `• Quantity: ${quantity}\n` +
    `• Price: ₹${price} each\n\n` +
    `Product link: ${productUrl}\n\n` +
    `Please confirm availability and delivery time. Thank you!`;

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

  const onClick = (e) => {
    e.stopPropagation();
    // Let the default anchor navigation happen — works on mobile + desktop.
    // Track event if you have analytics.
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'whatsapp_quick_buy', {
        product_id: product.id,
        product_name: product.name,
        value: price,
      });
    }
  };

  if (compact) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        data-testid={`whatsapp-quick-buy-${product.id}`}
        title="Order via WhatsApp"
        aria-label={`Order ${product.name} via WhatsApp`}
        className={`inline-flex items-center justify-center w-9 h-9 rounded-md bg-green-600 hover:bg-green-700 text-white shadow-sm transition ${className}`}
      >
        <MessageCircle size={16} />
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      data-testid={`whatsapp-quick-buy-${product.id}`}
      className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-green-600 hover:bg-green-700 text-white font-medium shadow-sm transition ${className}`}
    >
      <MessageCircle size={18} />
      Order via WhatsApp
    </a>
  );
};
